import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ConfigureService } from '@app/configure/services/configure.service';
import { ModalService } from '@app/core/services/modal.service';

import { FinanceQuote } from '@app/core/models/finance-quote.model';
import { ModalAction } from '@app/core/models/modal-action.model';
import { Modal } from '@app/core/models/modal.model';
import { HelperService } from '@app/core/services/helper.service';

@Component({
	selector: 'cng-finance-status-modal',
	templateUrl: './finance-status.component.html',
	styleUrls: ['./finance-status.component.less'],
})
export class ConfigureFinanceStatusModalComponent {
	data: any;
	quote: FinanceQuote;
	quote_expanded: boolean = false;
	vehicle: any;

	reserved: boolean = false;
	enquiry_hash: string;

	constructor(
		private modal_service: ModalService,
		private configure_service: ConfigureService,
		private router: Router,
		private helper_service: HelperService
	) {
		this.constructModal();
	}

	constructModal(): void {
		this.reserved = this.configure_service.configure_data.steps.payment.data.reservation.reserved;
		this.enquiry_hash = this.configure_service.configure_data.meta.enquiry_hash;
		this.data = this.modal_service.data;
		this.quote = this.data.quote;
		this.vehicle = this.data.vehicle;

		let action_id: string = 'reserve';
		let action_name: string = 'Reserve Now!';
		if (this.isProcessed() || this.isSubmitted() || this.reserved) {
			action_id = 'callback';
			action_name = 'Arrange Callback';
		}

		this.modal_service.setConfig(
			new Modal({
				name: 'finance_status_modal',
				title: 'Finance application update!',
				actions: [
					new ModalAction({
						id: action_id,
						name: action_name,
						bias: 'positive',
						large: true,
						showLoading: true,
						click: () => {
							switch (action_id) {
								case 'acknowledge':
									this.modal_service.close();
									break;
								case 'reserve':
									this.modal_service.close().then(() => {
										this.router.navigate(['/configure', 'e', this.data.enquiry_hash, 'reserve']);
									});
									break;
								default:
									this.modal_service.show(['configure/callback']);
							}
						},
					}),
				],
			})
		);
	}

	isApproved(): boolean {
		return this.quote.quote_status === 'Approved' || this.quote.quote_status === 'ConditionallyApproved';
	}

	isSubmitted(): boolean {
		return this.quote.quote_status === 'Submitted';
	}

	isProcessed(): boolean {
		return this.quote.quote_status === 'Processed';
	}

	getDisplayStatus(): string {
		if (this.quote.quote_status === 'Approved') {
			return 'Approved';
		}

		if (this.quote.quote_status === 'ConditionallyApproved') {
			return 'Conditionally Approved';
		}

		if (this.quote.quote_status === 'Processed') {
			return 'Processed';
		}

		if (this.quote.quote_status === 'Submitted') {
			return 'Submitted';
		}

		return 'Quote';
	}

	getActualStatus(): { name: string; friendly_name: string; icon: string } {
		const status = this.helper_service.getFinanceStatus(this.quote.status);

		return {
			name: status,
			friendly_name: this.helper_service.convertCase(status, 'pascal', 'title'),
			icon: this.helper_service.getFinanceStatusIcon(status),
		};
	}

	onManageApplication(): void {
		this.modal_service.close().then(() => {
			this.router.navigate(['/finance-manager', this.enquiry_hash]);
		});
	}

	getOpeningMessage(): string {
		if (this.quote.finance_provider_id === 3) {
			return 'You can do so in our Finance Manager. You are able to monitor the status of your application, recalculate your loan and be informed of any outstanding actions.';
		}

		return 'You can do so in our Finance Manager. You are able to upload proof documents, edit your details or recalculate your loan details.';
	}
}
